// Feather entry (DR-0045 D4): legacy/foreign routes (the old single-app wave
// URLs like /#/wave-solo?ai=zombie) redirect to their page BEFORE the engine
// boots — the hash (query included) is carried over wholesale. Everything else
// lazy-loads the real boot module, keeping the redirect path near-zero cost.
//
// `?go=<page>` is how the site router sends a moved game's old path here
// (play.actuniverse.com/firestrike/… → /?go=firestrike, hash kept). Before
// leaving for another subdomain, a sign-in still in this site's old
// localStorage moves into the site-wide cookie, so the game opens on the same
// account (ACT HQ DR-0017).
import { SITE_PAGES } from "@act/client-core/pages";
import { prepareSiteSession } from "@act/client-core/siteStorage";
import { FOREIGN_ROUTES } from "./routes";

const route = location.hash.replace(/^#\//, "").trim().split("?")[0] ?? "";
const go = new URLSearchParams(location.search).get("go");
const target = (go && go !== "hub" ? SITE_PAGES[go] : undefined) ?? FOREIGN_ROUTES[route];
if (target) {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
  if (supabaseUrl) prepareSiteSession(supabaseUrl);
  location.replace(`${target}${location.hash}`);
} else {
  // If the game's code can't load, the load-in screen (index.html) mustn't sit over the page for good.
  void import("./boot").catch((error: unknown) => {
    document.querySelector(".act-loadin")?.remove();
    throw error;
  });
}
